import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Activity from './Pages/Activity/index.tsx';
import ActivityCreate from './Pages/Activity/create.tsx';
import ActivityEdit from './Pages/Activity/edit.tsx';
import Bottle from './Pages/Bottle/index.tsx';
import BottleCreate from './Pages/Bottle/create.tsx';
import BottleEdit from './Pages/Bottle/edit.tsx';
import BottleCapacity from './Pages/BottleCapacity/index.tsx';
import BottleCapacityCreate from './Pages/BottleCapacity/create.tsx';
import BottleCapacityEdit from './Pages/BottleCapacity/edit.tsx';
import Country from './Pages/Country/index.tsx';
import CountryCreate from './Pages/Country/create.tsx';
import CountryEdit from './Pages/Country/edit.tsx';
import Producer from './Pages/Producer/index.tsx';
import ProducerCreate from './Pages/Producer/create.tsx';
import ProducerEdit from './Pages/Producer/edit.tsx';
import Region from './Pages/Region/index.tsx';
import RegionCreate from './Pages/Region/create.tsx';
import RegionEdit from './Pages/Region/edit.tsx';
import WineCellar from './Pages/WineCellar/index.tsx';
import WineCellarCreate from './Pages/WineCellar/create.tsx';
import WineCellarEdit from './Pages/WineCellar/edit.tsx';
import WineCellarSection from './Pages/WineCellarSection/index.tsx';
import WineCellarSectionCreate from './Pages/WineCellarSection/create.tsx';
import WineCellarSectionEdit from './Pages/WineCellarSection/edit.tsx';
import WineFarm from './Pages/WineFarm/index.tsx';
import WineFarmCreate from './Pages/WineFarm/create.tsx';
import WineFarmEdit from './Pages/WineFarm/edit.tsx';
import WineGrape from './Pages/WineGrape/index.tsx';
import WineGrapeCreate from './Pages/WineGrape/create.tsx';
import WineGrapeEdit from './Pages/WineGrape/edit.tsx';
import WineMaker from './Pages/WineMaker/index.tsx';
import WineMakerCreate from './Pages/WineMaker/create.tsx';
import WineMakerEdit from './Pages/WineMaker/edit.tsx';
import WinePhoto from './Pages/WinePhoto/index.tsx';
import WinePhotoCreate from './Pages/WinePhoto/create.tsx';
import WinePhotoEdit from './Pages/WinePhoto/edit.tsx';
import WineState from './Pages/WineState/index.tsx';
import WineStateCreate from './Pages/WineState/create.tsx';
import WineStateEdit from './Pages/WineState/edit.tsx';
import WineTastingNote from './Pages/WineTastingNote/index.tsx';
import WineTastingNoteCreate from './Pages/WineTastingNote/create.tsx';
import WineTastingNoteEdit from './Pages/WineTastingNote/edit.tsx';
import WineType from './Pages/WineType/index.tsx';
import WineTypeCreate from './Pages/WineType/create.tsx';
import WineTypeEdit from './Pages/WineType/edit.tsx';
import WineVariety from './Pages/WineVariety/index.tsx';
import WineVarietyCreate from './Pages/WineVariety/create.tsx';
import WineVarietyEdit from './Pages/WineVariety/edit.tsx';
import Wine from './Pages/Wine/index.tsx';
import WineCreate from './Pages/Wine/create.tsx';
import WineEdit from './Pages/Wine/edit.tsx';
import GrapeHarvestYear from './Pages/GrapeHarvestYear/index.tsx'
import GrapeHarvestYearCreate from './Pages/GrapeHarvestYear/create.tsx'
import GrapeHarvestYearEdit from './Pages/GrapeHarvestYear/edit.tsx'
import CustomFilter from './Components/Page/CustomFilter/CustomFilter';
import Login from './Pages/User/Login';
import Calendar from './Pages/Calendar/index.js';
import { LoginProvider } from './Pages/User/LoginContext';

ReactDOM.render(
  <BrowserRouter>
    <LoginProvider>
      <Routes>
        {/* <Route path="/" exact={true}element={<Page />} /> */}
        <Route path="/activities" exact={true} element={<Activity />} />
        <Route path="/activities/create" exact={true} element={<ActivityCreate />} />
        <Route path="/activities/edit/:page_id" exact={true} element={<ActivityEdit />} />
        <Route path="/bottles" exact={true} element={<Bottle />} />
        <Route path="/bottles/create" exact={true} element={<BottleCreate />} />
        <Route path="/bottles/edit/:page_id" exact={true} element={<BottleEdit />} />
        <Route path="/bottle-capacities" exact={true} element={<BottleCapacity />} />
        <Route path="/bottle-capacities/create" exact={true} element={<BottleCapacityCreate />} />
        <Route path="/bottle-capacities/edit/:page_id" exact={true} element={<BottleCapacityEdit />} />
        <Route path="/countries" exact={true} element={<Country />} />
        <Route path="/countries/create" exact={true} element={<CountryCreate />} />
        <Route path="/countries/edit/:page_id" exact={true} element={<CountryEdit />} />
        <Route path="/producers" exact={true} element={<Producer />} />
        <Route path="/producers/create" exact={true} element={<ProducerCreate />} />
        <Route path="/producers/edit/:page_id" exact={true} element={<ProducerEdit />} />
        <Route path="/regions" exact={true} element={<Region />} />
        <Route path="/regions/create" exact={true} element={<RegionCreate />} />
        <Route path="/regions/edit/:page_id" exact={true} element={<RegionEdit />} />
        <Route path="/wine-cellars" exact={true} element={<WineCellar />} />
        <Route path="/wine-cellars/create" exact={true} element={<WineCellarCreate />} />
        <Route path="/wine-cellars/edit/:page_id" exact={true} element={<WineCellarEdit />} />
        <Route path="/wine-cellar-sections" exact={true} element={<WineCellarSection />} />
        <Route path="/wine-cellar-sections/create" exact={true} element={<WineCellarSectionCreate />} />
        <Route
          path="/wine-cellar-sections/edit/:page_id"
          exact={true}
          element={<WineCellarSectionEdit />} />
        <Route path="/wine-farms" exact={true} element={<WineFarm />} />
        <Route path="/wine-farms/create" exact={true} element={<WineFarmCreate />} />
        <Route path="/wine-farms/edit/:page_id" exact={true} element={<WineFarmEdit />} />
        <Route path="/wine-grapes" exact={true} element={<WineGrape />} />
        <Route path="/wine-grapes/create" exact={true} element={<WineGrapeCreate />} />
        <Route path="/wine-grapes/edit/:page_id" exact={true} element={<WineGrapeEdit />} />
        <Route path="/wine-makers" exact={true} element={<WineMaker />} />
        <Route path="/wine-makers/create" exact={true} element={<WineMakerCreate />} />
        <Route path="/wine-makers/edit/:page_id" exact={true} element={<WineMakerEdit />} />
        <Route path="/wine-photos" exact={true} element={<WinePhoto />} />
        <Route path="/wine-photos/create" exact={true} element={<WinePhotoCreate />} />
        <Route path="/wine-photos/edit/:page_id" exact={true} element={<WinePhotoEdit />} />
        <Route path="/wine-states" exact={true} element={<WineState />} />
        <Route path="/wine-states/create" exact={true} element={<WineStateCreate />} />
        <Route path="/wine-states/edit/:page_id" exact={true} element={<WineStateEdit />} />
        <Route path="/wine-tasting-notes" exact={true} element={<WineTastingNote />} />
        <Route path="/wine-tasting-notes/create" exact={true} element={<WineTastingNoteCreate />} />
        <Route
          path="/wine-tasting-notes/edit/:page_id"
          exact={true}
          element={<WineTastingNoteEdit />} />
        <Route path="/wine-types" exact={true} element={<WineType />} />
        <Route path="/wine-types/create" exact={true} element={<WineTypeCreate />} />
        <Route path="/wine-types/edit/:page_id" exact={true} element={<WineTypeEdit />} />
        <Route path="/wine-varieties" exact={true} element={<WineVariety />} />
        <Route path="/wine-varieties/create" exact={true} element={<WineVarietyCreate />} />
        <Route path="/wine-varieties/edit/:page_id" exact={true} element={<WineVarietyEdit />} />
        <Route path="/grape-harvest-years" exact={true} element={<GrapeHarvestYear />} />
        <Route path="/grape-harvest-years/create" exact={true} element={<GrapeHarvestYearCreate />} />
        <Route path="/grape-harvest-years/edit/:page_id" exact={true} element={<GrapeHarvestYearEdit />} />
        <Route path="/wines" exact={true} element={<Wine />} />
        <Route path="/wines/create" exact={true} element={<WineCreate />} />
        <Route path="/wines/filter" exact={true} element={<CustomFilter />} />
        <Route path="/wines/edit/:page_id" exact={true} element={<WineEdit />} />
        <Route path="/login" exact={true} element={<Login />} />
        <Route path="/calendar" exact={true} element={<Calendar />} />
        <Route path="/*" exact={true} element={<Wine />} />        
      </Routes>
    </LoginProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
